import { z } from 'zod';
import { expiryRuleSchema, requirementKeySchema } from './requirements.js';
import { agencyCalendarDate, endOfDayInAgencyZone } from '../time/agency-dates.js';
export const screeningRecurrenceSchema = z.object({
    requirementKey: requirementKeySchema,
    expiry: expiryRuleSchema.refine((value) => ['none', 'unresolved', 'interval', 'calendar-months'].includes(value.mode), 'Choose a screening recurrence'),
    policyReference: z.string().trim().min(1).max(1000),
}).strict();
export const screeningRecurrencesSchema = z.array(screeningRecurrenceSchema).max(100).superRefine((rows, context) => {
    const seen = new Set();
    rows.forEach((row, index) => {
        if (seen.has(row.requirementKey))
            context.addIssue({ code: 'custom', path: [index, 'requirementKey'], message: 'Each screening needs one recurrence' });
        seen.add(row.requirementKey);
    });
});
/** The saved revision replaces only recurrence; applicability, gates and evidence remain intact. */
export function withScreeningRecurrence(rule, settings) {
    if (rule.policy.kind !== 'external-check')
        return rule;
    const override = settings?.find((row) => row.requirementKey === rule.rule.key);
    return override === undefined ? rule : { ...rule, policy: { ...rule.policy, expiry: override.expiry } };
}
/** Calendar arithmetic in the agency zone, never 30/182-day approximations or Date overflow. */
export function calendarMonthDueAt(anchor, everyMonths, alignment) {
    const date = agencyCalendarDate(anchor);
    const [year, month, day] = date.split('-').map(Number);
    const target = new Date(Date.UTC(year, month - 1 + everyMonths - (alignment === 'calendar-period' ? 1 : 0), 1));
    const lastDay = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
    target.setUTCDate(alignment === 'calendar-period' ? lastDay : Math.min(day, lastDay));
    return endOfDayInAgencyZone(target.toISOString().slice(0, 10));
}
//# sourceMappingURL=screening-recurrence.js.map